export const userApi = {
  list: {
      method: 'post',
      api: 'admin/users/list'
  },
  add: {
      method: 'post',
      api: 'admin/users/add'
  },
  edit: {
    method: 'post',
    api: 'admin/users/edit'
  },
  del: {
      method: 'post',
      api: 'admin/users/del'
  },
}